import Echo from 'laravel-echo';
import Pusher, { type ChannelAuthorizationCallback } from 'pusher-js';
import { axiosClient } from '@/services/apiClient';

declare global {
    interface Window { Pusher: typeof Pusher; }
}

let echoInstance: Echo<'pusher'> | null = null;

export function getEcho(): Echo<'pusher'> {
    if (!echoInstance) {
        window.Pusher = Pusher;

        const backendUrl = (process.env.VUE_APP_API_BASE_URL ?? '').replace(/\/api$/, '');

        echoInstance = new Echo({
            broadcaster: 'pusher',
            key: process.env.VUE_APP_PUSHER_APP_KEY,
            cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER ?? 'eu',
            forceTLS: true,
            authorizer: (channel: { name: string }) => ({
                authorize: (socketId: string, callback: ChannelAuthorizationCallback) => {
                    axiosClient
                        .post(`${backendUrl}/broadcasting/auth`, {
                            socket_id: socketId,
                            channel_name: channel.name,
                        })
                        .then(response => callback(null, response.data))
                        .catch(error => callback(error, null));
                },
            }),
        });
    }
    return echoInstance;
}